// extracted by mini-css-extract-plugin
var _1 = "VBrp76r3Oi";
export { _1 as "root" }
